import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import cls from "./ModalWindwow.module.css";

export default function ConfirmationModal({
  visible,
  setVisible,
  title,
  message,
  onConfirm,
  confirmText = "Ano",
  cancelText = "Ne",
}) {
  const theme = useTheme(); // <── máme aktivní light / dark motiv
  const rootClasses = [cls.myModal, visible && cls.active].filter(Boolean);

  return (
    <Box
      component="div"
      className={rootClasses.join(" ")}
      onClick={() => setVisible(false)}
      sx={{
        /* polos­klo pozadí – tmavší v dark režimu */
        backgroundColor:
          theme.palette.mode === "light"
            ? "rgba(0,0,0,0.50)"
            : "rgba(0,0,0,0.80)",
      }}
    >
      <Box
        component="div"
        className={cls.myModalContent}
        onClick={(e) => e.stopPropagation()}
        sx={{
          /* barvy modalu z tématu */
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          boxShadow: theme.shadows[24],
          borderRadius: 2,
          minWidth: 360,
          p: 3,
        }}
      >
        <Typography variant="h6" mb={1}>
          {title}
        </Typography>

        <Typography variant="body2">{message}</Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            mt: 3,
          }}
        >
          <Button onClick={() => setVisible(false)}>{cancelText}</Button>
          <Button
            variant="contained"
            onClick={() => {
              onConfirm();
              setVisible(false);
            }}
          >
            {confirmText}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
